export const PaymentStatuses = {
  Created: 'Created',
  Pending: 'Pending',
  Paid: 'Paid',
  Error: 'Error',
  Canceled: 'Canceled',
  Confirmed: 'Confirmed',
  Expired: 'Expired'
};
